<template>
  <div class="CollectionList">
    <!-- 有分类 -->
    <div
      ref="classifyBox"
      :class="{ 'Fixed': isFixed }"
      :style="[
        { top: isFixed == true ? headerHeight + 'px': 0 }
      ]"
      class="classify-box">
      <div class="inner_center"
           v-show="loading"
      >
        <div
          v-swiper:mySwiper="swiperOption"
          v-show="list.length"
          class="swiper"
        >
          <div class="swiper-wrapper">
            <div
              v-for="(vo,idx) in list"
              :key="idx"
              class="swiper-slide _pointer"
            >
              <div class="classify-item"
                   @click="toggleClassify(vo,idx)"
                   :class="{ 'ON' : idx == tabIndex }"
                   ref="tabItem"
              >
                {{ vo.show_word }}
                <div :style="[{width: idx == tabIndex ? currentClassifyItemWidth :0}]" class="tab-bar"></div>
              </div>
            </div>


          </div>
        </div>

        <i class="iconfont icon-a-arrowrightbold icon-a-arrowrightbold2 swiper-button-prev" slot="button-prev"></i>
        <i class="iconfont icon-a-arrowrightbold swiper-button-next" slot="button-next"></i>


        <!--        <div
                  v-for="(vo,idx) in list"
                  ref="tabItem"
                  :key="idx"
                  :class="{ 'ON' : idx === tabIndex }"
                  class="classify-item "
                  @click="toggleClassify(vo,idx)"
                >
                  {{ vo.show_word }}
                </div>-->
        <!--        <div
                  v-for="(vo,idx) in list"
                  ref="tabItem"
                  :key="idx"
                  :class="{ 'ON' : idx === tabIndex }"
                  class="classify-item "
                  @click="toggleClassify(vo,idx)"
                >
                  {{ vo.show_word }}
                </div>-->
        <!--        <i
                  :style="[{left:tabBarStyle.left},{width:tabBarStyle.width},]"
                  class="tab-bar"/>-->
      </div>
    </div>

    <div
      v-if="isFixed"
      ref="placeholder"
      class="placeholder"
    />

    <div
      ref="collectionList"
      class="collection-list">
      <div
        v-for="(vo,idx) in list"
        ref="collectionItem"
        :key="idx"
        class="collection-item">
        <CollectionListHeader
          :title="vo.show_word"
          :more-link="PAGE_PATH.TOPIC.COLLECTION + '/' + vo.id + '.html' "
        >
          <i
            slot="icon"
            class="icon_pic"/>

          <div slot="topicNum" class="topicNum">
            共{{ vo.picture_total }}张
          </div>
        </CollectionListHeader>

        <div class="inner_center">
          <PicList :pic-list="vo.pictures" v-bind="$attrs"
                   v-on="$listeners"/>
          <!--          <TupianList
                      :tupian-list="vo.pictures"
                      v-bind="$attrs"
                      v-on="$listeners"
                    >
                    </TupianList>-->
        </div>
      </div>
    </div>

    <!-- 无分类 -->
  </div>
</template>

<script>
import CollectionListHeader from '@/components/collection/collection-list/conllection-list-header'
import PicList from '@/components/pic/pic-list/pic-list';
import {fnBrowser} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import TupianList from "@/components/tupian/tupian-list"
import {mapState} from "vuex";

export default {
  name: "CollectionList",
  props: {
    picData: {
      type: Array,
      default: () => {
      }
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabBarStyle: {
        left: 0,
        width: 0
      },
      tabIndex: 0,
      isFixed: false,
      PAGE_PATH,
      scrollTop: 0,
      collectionItemTopArr: [],
      swiperOption: {
        /*autoplay: {
          delay: 5000,
          speed: 500,
          disableOninteraction: true
        },*/
        //配置分页
        pagination: {
          // el: '.swiper-pagination'//分页的dom节点
        },
        navigation: { // 左右箭头
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        direction: "horizontal",
        initialSlide: 0, // 默认选中
        // loop: false, // 在此无效？？？？？
        // centeredSlides: true, //活动块居中
        slideToClickedSlide: true, // 点击切换
        // slidesPerView: 'auto',
        slidesPerView: 'auto',
        spaceBetween: 48,
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        centeredSlides: false,
      },

      currentClassifyItemWidth: 0,
      loading: false
    }
  },
  components: {
    CollectionListHeader,
    PicList,
    TupianList
  },
  computed:{
    ...mapState("_Public/Header",['headerHeight'])
  },
  watch: {
    tabIndex: {
      handler(n, o) {
        if (n > -1) {
          // this.updateTab();
          setTimeout(() => {
            this.$nextTick(() => {
              let tabItemWidth = this.$refs.tabItem[this.tabIndex].offsetWidth - 22;
              this.currentClassifyItemWidth = tabItemWidth + 'px';
            })
          }, 500)
        }
      },
      immediate: true
    },
    scrollTop: {
      handler(n, o) {
        if (this.collectionItemTopArr.length && n > 0) {
          for (let i = 0; i < this.collectionItemTopArr.length; i++) {
            if (n >= this.collectionItemTopArr[i] - 2 - 60) {
              // this.toggleClassify(this.list[i],i);
              this.tabIndex = i;
            }
          }
        }
      }
    }
  },
  mounted() {

    window.addEventListener("scroll", this.scroll);

    /*this.$nextTick(() => {

      if (this.list.length){
        console.log(this.$refs.collectionItem)
        let tabItemLeft = this.$refs.tabItem[this.tabIndex].offsetLeft + 11;
        let tabItemWidth = this.$refs.tabItem[this.tabIndex].offsetWidth - 22;
        this.tabBarStyle.left = tabItemLeft + 'px';
        this.tabBarStyle.width = tabItemWidth + 'px';
      }
    })*/

    setTimeout(() => {
      this.tabIndex = 0;
      this.loading = true
    }, 100)

    window.onresize = () => {
      this.updateTab();
    }

    setTimeout(() => {
      this.updateTab();

      if (this.$refs.collectionItem) {
        let height = this.$refs.classifyBox.offsetHeight || this.$refs.placeholder.offsetHeight
        this.$nextTick(() => {
          let topArr = []
          this.$refs.collectionItem.forEach(vo => {
            topArr.push(vo.offsetTop - height - 40 - 55 - 10)
          })
          console.log(topArr)
          this.collectionItemTopArr = topArr
        })
      }


    }, 500)


  },
  destroyed() {
    window.onresize = null;
    document.removeEventListener('scroll', this.scroll);
  },
  methods: {

    updateTab() {
      if (this.$refs.tabItem) {
        this.$nextTick(() => {
          let tabItemLeft = this.$refs.tabItem[this.tabIndex].offsetLeft + 11;
          let tabItemWidth = this.$refs.tabItem[this.tabIndex].offsetWidth - 22;
          this.tabBarStyle.left = tabItemLeft + 'px';
          this.tabBarStyle.width = tabItemWidth + 'px';
        })
      }
    },
    //滚动分页加载数据
    scroll() {

      // console.log(document.documentElement.scrollTop)
      this.scrollTop = document.documentElement.scrollTop

      this.mySwiper.slideTo(this.tabIndex, 1000);

      if (this.isFixed) {
        this.isFixed = document.documentElement.scrollTop >= this.$refs.placeholder.offsetTop - this.$refs.placeholder.offsetHeight;
      } else {
        if (document.documentElement.scrollTop >= this.$refs.classifyBox.offsetTop - this.$refs.classifyBox.offsetHeight) {
          this.isFixed = true
        }
      }

      this.$emit("scroll", this.isFixed);
    },


    toggleClassify(vo, idx) {

      setTimeout(() => {
        console.log('this.isFixed' + this.isFixed)
        this.tabIndex = idx;
        let height = this.$refs.classifyBox.offsetHeight || this.$refs.placeholder.offsetHeight
        if (this.isFixed == false && idx != 0) {
          height += 70;
        }
        if (idx == 0){
          height += 10;
        }

        const temHeight = this.headerHeight > 80 ?  this.headerHeight - 80: 0;
        window.scrollTo(0, this.$refs.collectionItem[idx].offsetTop - height - 40 - 55 - 10 - temHeight);

      }, 100)
    },
  },

}
</script>

<style lang="scss" scoped>


/deep/ .FavoritesDefault {
  .Modal-cover {
    background: rgba(0, 0, 0, 0.05) !important;
  }
}

.CollectionList {


  .classify-box {

    position: relative;
    //margin: 0 auto 40px;
    margin: 0 auto 0px;
    background-color: #fff;
    width: 100%;
    border-bottom: 1px solid #ECEFF6;
    //height: 50px;
    //overflow: hidden;
    transition:all 0.3s ease;

    &.Fixed {
      position: fixed;
      top: 80px;
      left: 0;
      z-index: 99;
    }

    .inner_center {
      display: flex;
      align-items: center;
      //justify-content: center;
      position: relative;
    }


    .classify-item {
      margin-right: 48px;
      font-size: 20px;
      font-weight: bold;
      color: rgba(66, 72, 102, 0.85);
      line-height: 70px;
      letter-spacing: 1px;
      cursor: pointer;
      white-space: nowrap;

      @include ElementHover(#424866, '');


      &.ON {
        color: #F94D67;

        .tab-bar {
          width: 76px;
          height: 3px;
          background: #F94D67;
          border-radius: 1px;
          @include Position(1, 4, 50%, 0px);
          transform: translateX(-50%);
          transition: all 0.3s ease-in-out;
        }
      }


      &:last-child {
        margin-right: 0;
      }


    }

    /*.tab-bar {
      width: 76px;
      height: 3px;
      background: #F94D67;
      border-radius: 1px;
      @include Position(1, 4, 0px, 0px);
      transition: all 0.3s ease-in-out;
    }*/
  }

  .placeholder {
    height: 70px;
  }

  .collection-list {
    //position: relative;

    /* &:after {
       content: '';
       display: inline-block;
       width: 100%;
       border-bottom: 1px solid #ECEFF6;
       @include Position(1, 5, 0, -40px);
     }*/
    margin-top: 40px;

    .collection-item {
      margin-bottom: 35px;

      .icon_pic {
        @include BgImage(28px, 28px, 'topic/index/icon_pic.svg');
        margin-right: 14px;
      }
    }
  }

}

.topicNum {
  //width: 62px;
  height: 26px;
  background: #F5F6FA;
  border-radius: 13px;
  font-size: 12px;
  color: #2D2B33;
  padding: 0 12px;
  line-height: 26px;
  text-align: center;
  margin-left: 10px;
}


.swiper-wrapper {
  display: flex;
  //width: 500px;
  position: relative;
  //max-width: 100%;
  //overflow: visible !important;

  /deep/ .swiper-slide {
    //margin-right: 48px;
  }
}

.swiper-container {
  width: 100%;

}

.swiper-slide {
  width: auto;
}

.icon-a-arrowrightbold {
  width: 36px;
  height: 36px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(10, 37, 64, 0.1000);
  @include Position(1, 2, -36px, 50%);
  transform: translateY(-50%);
  border-radius: 50%;
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  z-index: 10;
  margin-left: -36px;

  @include ElementHover(#FFFFFF, $color-primary);
  margin-top: 0 !important;


  &.icon-a-arrowrightbold2 {
    @include Position(1, 4, -6px, 50%);
    transform: translateY(-50%) rotate(180deg);
  }

  &.swiper-button-disabled {
    display: none;
  }
}
</style>
